import { CircularProgress, Typography } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import useLogout from '../../hooks/useLogout'
import { getSessionToken, initApi, loginParseLegacy } from '../../api/auth'
import RouterOutsideContainer from '../../routers/RouterOutsideContainer'

type ParseGuardProps = {
    children: ReactNode
}

export const ParseGuard = ({ children }: ParseGuardProps) => {
    const { loading: isLoadingLogout, logout } = useLogout()
    const [isLoadingInit, setIsLoadingInit] = useState<boolean>(true)

    useEffect(() => {
        const initParse = async () => {
            setIsLoadingInit(true)
            await initApi()
            try {
                const token = await getSessionToken()
                await loginParseLegacy(token)
                localStorage.setItem('sessionToken', token)
            } catch (error) {
                logout()
            }
            setIsLoadingInit(false)
        }

        initParse()
    }, [logout])

    if (isLoadingInit || isLoadingLogout)
        return (
            <RouterOutsideContainer>
                <CircularProgress size="3.6rem" />
                <Typography fontWeight={600} fontSize="1.6rem">
                    Chargement de l'espace TokTokDoc
                </Typography>
            </RouterOutsideContainer>
        )

    return children
}
